import * as React from 'react';
import { login } from '../auth';

import discoveryImage from '../images/discovery.png';
import msLoginImage from '../images/ms-login.svg';

export default () => (
  <section className="container limited-width">
    <div className="boxes teasers">
      <div className="teaser">
        <img className="teaser-image" src={discoveryImage} alt="Piral Cloud Teaser" />
      </div>
      <div className="teaser">
        <h1>Piral Cloud Feed Service</h1>
        <ul>
          <li>The easiest way to publish your micro frontends</li>
          <li>Get multiple feeds - for free<sup>*</sup></li>
          <li>Configure the allowed clients</li>
          <li>Specify configurations for your micro frontends</li>
          <li>Manage API keys for configuring who can publish</li>
          <li>Roll out your micro frontends with feature flags</li>
        </ul>
        <div className="login">
          <a href="#" onClick={() => login()}>
            <img src={msLoginImage} alt="Microsoft Login" />
          </a>
        </div>
        <small>
          <sup>*</sup> For the free tier certain restrictions apply. The conditions are subject to change.
        </small>
      </div>
    </div>
  </section>
);
